export default __webpack_public_path__ + "static/media/screen.45af9210.png";